import { configure } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import de from '@vee-validate/i18n/dist/locale/de.json'
import en from '@vee-validate/i18n/dist/locale/en.json'
import './rules'
import { names } from './names'

configure({
	generateMessage: localize({
		de: {
			messages: {
				...de.messages,
			},
			names,
		},
		en: {
			messages: {
				...en.messages,
			},
		},
	}),
})

setLocale('de')
